import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import ChatConversation from 'components/Chat/ChatConversation';
import ChatConversationLoading from 'components/Chat/ChatConversationLoading';
import ChatMessageInput from 'containers/Chat/ChatMessageInput/ChatMessageInputContainer';
import Spinner from 'components/MainSpinner/MainSpinner';
import { injectIntl, FormattedMessage } from 'react-intl';
import classes from './InCallChat.module.scss';

export class InCallChat extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingMoreMessages: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isVisible !== nextProps.isVisible && nextProps.hasJoinedChat) {
      this.props.markMessagesAsRead(this.props.chatContact);
    }

    if (!this.props.isVisible && nextProps.isVisible && this.props.hasJoinedChat) {
      this.props.markMessagesAsRead(this.props.chatContact);
    }
  }

  onJoinInCallChat = () => {
    if (!this.props.chatContact) return;
    this.props.joinChat(this.props.chatContact);
  };

  renderInCallChat() {
    const {
      chatContact,
      conversation,
      hasNewChat,
      isChatLoading,
      isGettingMessages,
      onBookmarkScroll,
      onGetMoreMessages,
      resetChatFlag,
      scrollBookmarks
    } = this.props;
    return (
      <div className={classes.inCallChat}>
        {isChatLoading ? (
          <div style={{ flex: '1 1 0', position: 'relative' }}>
            <Spinner
              config={{
                lines: 13,
                length: 17,
                width: 8,
                radius: 20,
                color: '#413675',
                speed: 0.7
              }}
            />
          </div>
        ) : (
          <ChatConversation
            conversation={conversation}
            isGettingMessages={isGettingMessages}
            isInCall
            onBookmarkScroll={onBookmarkScroll}
            onGetMoreMessages={onGetMoreMessages}
            hasNewChat={hasNewChat}
            resetChatFlag={resetChatFlag}
            scrollBookmarks={scrollBookmarks}
          />
        )}

        <div className={classes.conversationCompose}>
          <ChatMessageInput chatContact={chatContact} conversation={conversation} isInCall />
        </div>
        {this.state.loadingMoreMessages ? <ChatConversationLoading show={this.state.loadingMoreMessages} /> : null}
      </div>
    );
  }

  renderJoinMessage() {
    // JoinChat button should not be rendered if call is p2p

    return (
      <section className={classes.joinInCallChat}>
        <div className={classes.joinInCallChatMessage}>
          <FormattedMessage
            id="components.inCall.inCallChat.joinMessage"
            description="In call chat join message"
            defaultMessage="Would you like to join the meeting chat?"
          />
        </div>
        <button className={classes.primaryButton} onClick={this.onJoinInCallChat}>
          <FormattedMessage
            id="components.inCall.inCallChat.joinButton"
            description="In call chat join button"
            defaultMessage="Join"
          />
        </button>
      </section>
    );
  }

  render() {
    return (
      <div className={`${classes.container} ${this.props.isVisible ? '' : classes.hiddenDrawer}`}>
        <header className={classes.drawerTitle}>
          <FormattedMessage
            id="components.inCall.chat.header"
            description="In call chat header"
            defaultMessage="Chat"
          />
        </header>
        {this.props.hasJoinedChat ? this.renderInCallChat() : this.renderJoinMessage()}
      </div>
    );
  }
}

InCallChat.propTypes = {
  chatContact: PT.object,
  conversation: PT.object,
  enterConversation: PT.func.isRequired,
  hasJoinedChat: PT.bool.isRequired,
  hasNewChat: PT.bool,
  isChatLoading: PT.bool,
  isFullyConnected: PT.bool,
  isGettingMessages: PT.bool,
  isMeeting: PT.bool,
  isVisible: PT.bool,
  joinChat: PT.func.isRequired,
  markMessagesAsRead: PT.func,
  onBookmarkScroll: PT.func,
  onGetMoreMessages: PT.func,
  resetChatFlag: PT.func,
  remoteContact: PT.object,
  scrollBookmarks: PT.object
};

export default injectIntl(InCallChat);
